export default __webpack_public_path__ + "static/leandro-cv-64fd5f772e78a8113da89d2e0a1220fa.png";